import { useEffect, useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { api } from '../api/client';
import { useAuth } from '../auth/AuthContext';

export function LoginPage() {
  const { login, loading } = useAuth();
  const navigate = useNavigate();
  const [players, setPlayers] = useState<string[]>([]);
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loadingPlayers, setLoadingPlayers] = useState(true);

  useEffect(() => {
    api.get<string[]>('/players/active')
      .then(({ data }) => {
        setPlayers(data);
        if (data.length > 0) setName((current) => current || (data[0] ?? ''));
      })
      .catch(() => {
        setError('Spielerliste konnte nicht geladen werden');
      })
      .finally(() => setLoadingPlayers(false));
  }, []);

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(null);
    if (!name) {
      setError('Bitte Spieler auswählen');
      return;
    }
    if (!password) {
      setError('Passwort fehlt');
      return;
    }
    try {
      await login(name, password);
      navigate('/', { replace: true });
    } catch (err) {
      const message = axios.isAxiosError(err) && err.response?.status === 401
        ? 'Name oder Passwort falsch'
        : 'Login fehlgeschlagen — versuch es nochmal';
      setError(message);
    }
  };

  return (
    <main className="login">
      <div className="login__emojis" aria-hidden="true">🟩🟥🟨🟩</div>
      <h1 className="login__title">Pastpuzzle</h1>
      <p className="login__subtitle">Nur für die Runde.</p>

      <form className="login__form" onSubmit={submit}>
        <label className="field">
          <span className="field__label">Spieler</span>
          <select
            className="field__input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={loadingPlayers || loading}
            required
          >
            {loadingPlayers && <option value="">lädt …</option>}
            {!loadingPlayers && players.length === 0 && (
              <option value="">keine Spieler</option>
            )}
            {players.map((p) => (
              <option key={p} value={p}>{p}</option>
            ))}
          </select>
        </label>

        <label className="field">
          <span className="field__label">Passwort</span>
          <input
            className="field__input"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
            required
          />
        </label>

        {error && <p className="login__error" role="alert">{error}</p>}

        <button
          className="button button--primary"
          type="submit"
          disabled={loading || loadingPlayers}
        >
          {loading ? 'Anmelden …' : 'Anmelden'}
        </button>
      </form>

      <p className="login__hint">
        Bleibt 90 Tage angemeldet. Logout oben rechts auf der Startseite.
      </p>
    </main>
  );
}
